import React from 'react';

export default function Brochure() {
  const openPdfInNewWindow = (brochure) => {
    // Open a new window
    const newWindow = window.open(brochure.path, '_blank', 'noopener,noreferrer');
    
    // Attempt to set title and favicon (browser security may limit this)
    if (newWindow) {
      newWindow.onload = function() {
        try {
          // Set window title
          newWindow.document.title = `${brochure.title} - Northern Professional`;
          
          // Create and add favicon
          const link = newWindow.document.createElement('link');
          link.type = 'image/x-icon';
          link.rel = 'shortcut icon';
          link.href = '/assets/npke_logo.png'; 
          newWindow.document.head.appendChild(link);
        } catch (e) {
          console.log('Unable to modify new window:', e);
        }
      };
    }
  };
  const brochures = [
    {
      id: 1,
      title: "Company Profile",
      description: "Learn about our company history and services",
      path: "/pdfs/pdf_01.pdf"
    },
    {
      id: 2,
      title: "Kitchen Containers",
      description: "Browse our full range of catering equipment",
      path: "/pdfs/pdf_02.pdf"
    },
    {
      id: 3,
      title: "Custom Display Showcase",
      description: "Technical specifications and installation procedures",
      path: "/pdfs/pdf_03.pdf"
    }
  ];

  return (
    <div className="pb-16 bg-gray-100">
      <div className="container mx-auto px-5 md:px-16">
        <h2 className="text-3xl font-bold text-center text-indigo-900 mb-2">Our Brochures</h2>
        <p className="text-center text-gray-600 mb-12">View our latest brochures and catalogs</p>

        <div className="grid md:grid-cols-3 gap-8">
          {brochures.map((brochure) => (
            <div key={brochure.id} className="bg-white rounded-lg shadow-md p-6 flex flex-col">
              <div className="flex-1">
                <h3 className="text-xl font-semibold text-indigo-900 mb-2">{brochure.title}</h3>
                <p className="text-gray-600 mb-4">{brochure.description}</p>
              </div>
              <button 
                onClick={() => openPdfInNewWindow(brochure)}
                className="w-full py-3 bg-indigo-900 text-white font-medium rounded hover:bg-indigo-800 transition-colors flex items-center justify-center"
              >
                <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                </svg>
                View Brochure
              </button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}